import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-plan-details',
    templateUrl: './plan-details.component.html',
    styleUrls: ['./plan-details.component.css'],
    standalone: false
})
export class PlanDetailsComponent {

 constructor( private router: Router) {}
  onUpgrade(){
    this.router.navigate(['/upgrade','Pro'])
  }
}
